import React from "react";
import styled, { css } from "styled-components";
import * as Colors from "./colors";

export const Divider = styled.div`
  min-width: ${p => p.width || p.w};
  min-height: ${p => p.height || p.h};
`;

export const HR = styled.hr`
  width: ${p => p.width || "50%"};
  height: ${p => p.height || "2px"};
  background-color: ${p => p.color};
  border-radius: 20px;
`;

export const HRPrimary = p => <HR {...p} color={Colors.primary} />;

export const VCenter = css`
  display: flex;
  align-items: center;
`;

export const HCenter = css`
  display: flex;
  justify-content: center;
`;

export const CenterMe = styled.div`
  ${VCenter}
  ${HCenter}
`

export const Fill = styled.div`
  width: 100%;
  height: 100%;
`;

export const ShowWhen = ({ pred, children, p }) => (pred || p ? <span>{children}</span> : null);

export class Showable extends React.Component {
  constructor() {
    super();
    this.state = {
      show: false
    };
  }

  componentDidMount() {
    setTimeout(() => this.setState({ show: true }), 100);
  }

  render() {
    return <span>{React.cloneElement(this.props.children, { show: this.state.show })}</span>;
  }
}

export class AutoFocus extends React.Component {
  componentDidMount() {
    this.input.focus();
  }

  render() {
    return <input {...this.props} ref={ref => (this.input = ref)} />;
  }
}



// WEBPACK FOOTER //
// ./src/reusable/layout.js